// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration=qa` replaces `environment.ts` with `environment.qa.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: any = { // eslint-disable-line @typescript-eslint/no-explicit-any
  authority: 'https://login.microsoftonline.com/906aefe9-76a7-4f65-b82d-5ec20775d5aa/',
  BPUserKeyword: 'Contractor',
  clientId: '5fc81598-8a0d-41a8-b2d9-df887fedf2a6',
  continuityUrls: {
    /* eslint-disable @stylistic/js/quote-props */
    'central': 'https://10.146.103.201/ContinuitySPS/go?mode=read-only',
    'ned': 'https://68.87.92.14/ContinuitySPS/go?mode=read-only',
    'west': 'https://68.87.89.140/ContinuitySPS/go?mode=read-only'
    /* eslint-enable */
  },
  env: 'qa',
  LOG_LEVEL: 1,
  personnaUrl: 'https://nwt-api-gateway-qaccp.ho-g2.cf.comcast.net/nwt-svc-logger/',
  powerCompanyFinderUrl: 'https://cdxoc.cable.comcast.com/apps/power_lookup/',
  production: false,
  psnbBaseUri: 'https://psnb-mobile-qa.comcast.net',
  pullTransponderUseGenome: true,
  redirectUri: 'https://psnb-mobile-qa.comcast.net',
  scope: ['openid', 'profile', 'email', 'api://5fc81598-8a0d-41a8-b2d9-df887fedf2a6/basic-access'],
  SERVER_LOG_LEVEL: 1,
  subsystem: 'Mobile',
  system: 'PSNB',
  thirtyDaysInMilliseconds: 2592000000 // change the inspection date if more than 30 days from the old inspection date
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
